module.exports = __webpack_public_path__ + "static/media/md-share.98db64c4.svg";